import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ChevronRight = (props: any) => {
  return <ChevronRightIcon {...props} />;
};

export default ChevronRight;
